import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';

@Component({
  selector: 'era-master-detail',
  templateUrl: './master-detail.component.html',
  styleUrls: ['./master-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, RouterOutlet],
})
export class MasterDetailComponent {
  readonly flexGrowLeft = input(1);
  readonly flexGrowRight = input(1);

  readonly isH2 = input(true);

  public hasDetail = false;

  activated() {
    this.hasDetail = true;
  }

  deactivated() {
    this.hasDetail = false;
  }
}
